import { render, staticRenderFns } from "./okrdashboard.vue?vue&type=template&id=784ac566&"
import script from "./okrdashboard.vue?vue&type=script&lang=js&"
export * from "./okrdashboard.vue?vue&type=script&lang=js&"
import style0 from "./okrdashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports